import styled from 'styled-components';

export const Heading = styled.h1`
  margin: 0 0 0 4px;
  font-size: 1.2rem;
  line-height: 1;

  ${Styles.desktop`
    font-size: 2rem;
    margin: 75px 0 5px 0;
  `}
`;
